import { render } from "./StoreMasterPage.vue?vue&type=template&id=6f007e9d&scoped=true"
import script from "./StoreMasterPage.vue?vue&type=script&lang=js"
export * from "./StoreMasterPage.vue?vue&type=script&lang=js"

import "./StoreMasterPage.vue?vue&type=style&index=0&id=6f007e9d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3657311707/src/hybrid_inventory_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f007e9d"]])

export default __exports__